<!-- 九宫格 -->
<template>
  <div class="game-1">
    <nf-card borderInnerSize="0" round=".2rem">
      <div class="game-1-box">
        <div class="game-1-box-title"></div>
        <div class="game-1-box-list">
          <!-- 左右滑动，一个Swipeitem中有8张图片，一行4个 -->
          <Grid :column-num="3" :border="false">
            <GridItem
              v-for="(subitem, subindex) in cardList"
              :key="subindex"
              v-show="!selectIdList.includes(subitem.id)"
              @dblclick.native="doubleSelectCardHandle(subitem)"
            >
              <div
                class="game-1-box-list-item"
                :class="{ active: activeCard == subitem.id }"
                @click="activeCard = subitem.id"
              >
                <VanImage
                  height="100%"
                  :src="
                    subitem.isFront != 1 ? subitem.reverseImg : subitem.frontImg
                  "
                  fit="fill"
                  radius="5"
                />
                <div
                  class="game-1-box-list-item-open"
                  @click.stop="previewImgHandle(subitem)"
                >
                  <Icon name="search" size="0.3rem" />
                </div>
              </div>
            </GridItem>
          </Grid>
          <NfButton
            color="rgb(255,211,94)"
            round=".5rem"
            style="margin-top: 0.2rem"
            @click.native="selectCardHandle"
            >选择卡片</NfButton
          >
          <div class="game-1-box-list-divider"></div>
          <!-- <CardReverseAndConfirm
            :selectIdList.sync="selectIdList"
            :gameInfo="gameInfo"
            :userInfo="userInfo"
            :playerId="formValue.roleTab"
            :playerName="formValue.roleName"
            :sizeType="sizeType"
            :gameStatus="gameStatus"
            @confirm="confirmHandle"
          /> -->
          <div class="game-1-box-list-select">
            <Grid :column-num="sizeType != 'small' ? 3 : 4" :border="false">
              <GridItem
                v-for="(subitem, subindex) in formValue.selectCardList"
                :key="subindex"
              >
                <div
                  class="game-1-box-list-select-card-item"
                  :class="{
                    active: selectActiveCard == subitem.id,
                    small: sizeType == 'small',
                    middle: sizeType == 'middle',
                  }"
                  @click="selectActiveCard = subitem.id"
                >
                  <VanImage
                    height="100%"
                    :src="
                      subitem.isFront != 1
                        ? subitem.reverseImg
                        : subitem.frontImg
                    "
                    fit="cover"
                    radius="5"
                  />
                </div>
              </GridItem>
            </Grid>
            <!-- 选中的卡片按钮 -->
            <div class="game-1-box-list-select-btns">
              <NfButton
                color="rgb(255,211,94)"
                round=".5rem"
                style="margin-top: 0.2rem"
                class="game-1-box-list-select-btns-btn"
                @click.native="revertCardHandle"
                >放回卡片</NfButton
              >

              <NfButton
                color="rgb(172,185,233)"
                round=".5rem"
                style="margin-top: 0.2rem"
                class="game-1-box-list-select-btns-btn"
                @click.native="confirmHandle"
                >确认选择</NfButton
              >
            </div>
          </div>
        </div>
      </div>
    </nf-card>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Icon,
  ImagePreview,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
// import CardReverseAndConfirm from "./CardReverseAndConfirm.vue";
export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
        };
      },
    },
    cardList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      selectCardList: [],
      selectActiveCardList: [],
      activeCard: 0,
      selectIdList: [],

      selectActiveCard: 0,
    };
  },
  components: {
    NfCard,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    Icon,
    ImagePreview,
    // CardReverseAndConfirm,
  },
  computed: {
    list: {
      get() {
        const list = [];
        const arr = [];
        this.cardList.forEach((item, index) => {
          arr.push({
            ...item,
          });
          if ((index + 1) % 8 == 0) {
            list.push(arr);
            arr = [];
          }
          // 如果是最后一张
          if (index == this.cardList.length - 1) {
            list.push(arr);
          }
        });
        return list;
      },
    },
    formValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:value", {
          ...val,
        });
      },
    },
  },
  methods: {
    // 选择卡牌
    selectCardHandle() {
      // 如果超出最大可抽取的数量则提示
      // if (
      //   this.formValue.playerCardList[this.formValue.roleTab].length >=
      //   this.gameInfo.extractNum
      // ) {
      //   this.$dialog.message(
      //     "已达到最大可抽取数量，请放回部分卡牌或者确认选择"
      //   );
      //   return;
      // }
      // const item = this.cardList.find((item) => item.id == this.activeCard);
      // // 已存在则返回
      // if (
      //   this.formValue.playerCardList[this.formValue.roleTab].find(
      //     (item) => item.id == this.activeCard
      //   )
      // ) {
      //   this.$dialog.message("卡牌已存在");
      //   return;
      // }
      // this.formValue.playerCardList[this.formValue.roleTab].push({
      //   ...item,
      // });

      if (this.formValue.selectCardList.length >= this.gameInfo.extractNum) {
        this.$dialog.message(
          "已达到最大可抽取数量，请放回部分卡牌或者确认选择"
        );
        return;
      }
      const item = this.cardList.find((item) => item.id == this.activeCard);
      // 已存在则返回
      if (
        this.formValue.selectCardList.find((item) => item.id == this.activeCard)
      ) {
        this.$dialog.message("卡牌已存在");
        return;
      }

      this.formValue.selectCardList.push({ ...item });
    },
    // 确认选择
    confirmHandle(data) {
      // if (this.formValue.successSaveUser.includes(this.formValue.roleTab)) {
      //   this.$dialog.message("该玩家已记录");
      //   return;
      // }
      this.$dialog.message("您可提示用户点击此按钮进行提交操作");
      this.$emit("confirm", data);
    },
    revertCardHandle() {
      const index = this.formValue.selectCardList.findIndex(
        (item) => item.id == this.selectActiveCard
      );
      if (index != -1) {
        this.formValue.selectCardList.splice(index, 1);
      } else {
        this.$dialog.message("请选择需要放回的卡牌");
      }
    },
    // 双击选择卡牌
    doubleSelectCardHandle(item) {
      // 如果超出最大可抽取的数量则提示
      if (this.formValue.selectCardList.length >= this.gameInfo.extractNum) {
        this.$dialog.message(
          "已达到最大可抽取数量，请放回部分卡牌或者确认选择"
        );
        return;
      }
      // 已存在则返回
      const isExist = this.formValue.playerCardList[
        this.formValue.roleTab
      ].find((item) => item.id == this.activeCard);
      if (isExist) {
        this.$dialog.message("卡牌已存在");
        return;
      }
      this.formValue.selectCardList.push({
        ...item,
      });
    },
    previewImgHandle(item) {
      const img = item.isFront != 1 ? item.reverseImg : item.frontImg;
      ImagePreview({
        images: [img],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.1rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }

      &-item {
        box-sizing: border-box;
        border-radius: 0.2rem;
        // overflow: hidden;
        height: 2.9rem;
        width: 100%;
        position: relative;

        &-open {
          position: absolute;
          top: -0.15rem;
          right: -0.15rem;
          border-radius: 50%;
          width: 0.6rem;
          height: 0.6rem;
          background: #eee;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .active {
        border: 0.06rem solid #666eee;
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }
}

::v-deep .van-grid {
  justify-content: center;
}
</style>
